"use strict";
exports.__esModule = true;
exports.getAdditionalChartCallback = exports.getChartOptions = void 0;
function makeLines(mainSeries, shadowSeries) {
    var answer = [];
    for (var _i = 0, mainSeries_1 = mainSeries; _i < mainSeries_1.length; _i++) {
        var m = mainSeries_1[_i];
        for (var _a = 0, shadowSeries_1 = shadowSeries; _a < shadowSeries_1.length; _a++) {
            var s = shadowSeries_1[_a];
            if (m.name === s.name) {
                answer.push({
                    showInLegend: false,
                    type: 'line', color: '#f9a65a', zIndex: 4,
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    },
                    linkedTo: ':previous',
                    data: [{
                            x: m.x,
                            y: m.y
                        }, {
                            x: s.x,
                            y: s.y
                        }
                    ]
                });
            }
        }
    }
    return answer;
}
function getXMinMax(series, verticalCutoff) {
    var xMin = verticalCutoff;
    var xMax = verticalCutoff;
    series.forEach(function (s) {
        if (s.length > 0) {
            xMin = Math.min(s[0].x, xMin);
            xMax = Math.max(s[s.length - 1].x, xMax);
        }
    });
    var fix = (xMax - xMin) / 10.0;
    return [xMin - fix, xMax + fix];
}
function generateSeries(dataRows, legends, zindex) {
    if (zindex === void 0) { zindex = 6; }
    var series = [];
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) {
            return item.colorTag === tagKey && typeof item.y !== 'undefined';
        });
        if (seriesData.length > 0) {
            series.push({
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            });
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return series;
}
function getChartOptions(graph, options) {
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return a.x - b.x; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return a.x - b.x; });
    var series = generateSeries(mainSeriesData, legends, 6);
    var drilldown = graph.mainDrillDown;
    var lines = [];
    if (siblingSeriesData.length > 0) {
        lines = makeLines(mainSeriesData, siblingSeriesData);
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5);
        series = series.concat(siblingSeries, lines);
        drilldown = drilldown.concat(graph.siblingDrillDown);
    }
    // This var (drilldownSeries) is only for finding x axis range.
    var drilldownSeries = drilldown.reduce(function (se, s) { return se.concat(s.data); }, []).sort(function (a, b) { return a.x - b.x; });
    var xAxisRange = getXMinMax([mainSeriesData, siblingSeriesData, drilldownSeries], settings.verticalDivider);
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'scatter',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name) {
                    return "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" +
                        (graph.yTitle + ": <b>" + this.point.y.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.x.toFixed(settings.decimals) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: [{
                min: xAxisRange[0],
                max: xAxisRange[1],
                title: {
                    enabled: true,
                    text: graph.xTitle
                },
                showLastLabel: true,
                plotLines: [{
                        value: 0,
                        color: 'black',
                        width: 3,
                        zIndex: 2
                    }, {
                        value: settings.verticalDivider,
                        color: '#62CDCD',
                        width: 3,
                        zIndex: 2
                    }]
            }, {
                lineColor: "white",
                title: {
                    enabled: true,
                    text: "White Elephants",
                    align: 'low',
                    style: {
                        color: '#A85252',
                        fontSize: '14px'
                    }
                }
            }, {
                lineColor: "white",
                title: {
                    enabled: true,
                    margin: -20,
                    text: "Oysters",
                    align: 'high',
                    style: {
                        color: '#A85252',
                        fontSize: '14px'
                    }
                }
            }],
        yAxis: {
            min: 0,
            max: 1,
            tickInterval: 0.1,
            title: {
                enabled: true,
                text: graph.yTitle
            },
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 3,
                    zIndex: 2
                }, {
                    value: 0.5,
                    color: '#62CDCD',
                    width: 3,
                    zIndex: 2
                }]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                dataLabels: {
                    enabled: settings.showLabel,
                    style: {
                        fontWeight: 'thin'
                    },
                    formatter: function () {
                        if (!this.series.name || this.series.name.indexOf(":") !== -1) {
                            this.series.name = nodeName;
                        }
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                },
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series,
        drilldown: {
            activeAxisLabelStyle: {
                textDecoration: 'none',
                cursor: 'default',
                color: '#666666',
                'font-weight': 'normal',
                'pointer-events': 'none'
            },
            series: drilldown
        }
    };
}
exports.getChartOptions = getChartOptions;
function getAdditionalChartCallback() {
    return function chartCallback(chart) {
        chart.renderer.text("Bread & Butter ", 70, 32)
            .css({
            color: '#A85252',
            fontSize: '14px'
        }).add();
        chart.renderer.text("Pearls ", 520, 32)
            .css({
            color: '#A85252',
            fontSize: '14px'
        }).add();
    };
}
exports.getAdditionalChartCallback = getAdditionalChartCallback;
//# sourceMappingURL=innovation-screen.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/innovation-screen2/innovation-screen.chart.js